const TEXT_TYPES = {
  TEXT: 'text',
  MARKDOWN: 'markdown',
};

export { TEXT_TYPES };
